import { useTranslations } from 'next-intl'

function WorldLabels() {
  const t = useTranslations()

  return (
    <div className="flex gap-2">
      <span className="text-primary-500 subheader-3 text-vive-primary-70 bg-vive-primary-20 flex items-center rounded-[3px] px-2 py-1 text-xs">
        {t('world-info.labels.showroom')}
      </span>
    </div>
  )
}

export default WorldLabels
